
import { useEffect } from 'react';
import { IconCheck } from '../img'
import { Input, CheckBoxOnly, RadioButton } from './'
import { typeCobEnum } from '../data/MochaData'

const TableRow = ({ row, change , prefix}: ITableRowAutoCR) => {


    const onChangeCbo = (prop: any, value: string) => change(row.idCob, prop, value);

    const onChangeCheck = (event: any) => {
        const data = event.target.name.split('_')
        change(row.idCob, data[1], event.target.checked);
    }

    const onChangeCheck2 = (prop: string, value: string) => {
        const data = prop.split('_')
        change(row.idCob, data[0], value);
    }

    const onChangeInput = (e: any) => {
        const data = e.target.name.split('_')
        change(row.idCob, data[0], e.target.value);
    }

    const onChangeInput2 =  (property: string, value: string) =>  {
        const data = property.split('_')
        change(row.idCob, data[0], value);
    }   
    

    //change(row.idCob, e.target.name , e.target.value);


    return (
        <>
            {!row.obligatoria &&
                <div className='mt-10'>
                    <CheckBoxOnly
                        field={`${row.idCob}_checked`}
                        key={row.idCob}
                        label={row.nombre}
                        onChange={onChangeCheck}
                        value={row.checked}
                    />
                </div>
            }
            {row.obligatoria &&
                <div className='mt-10 lbl-cob' style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <div className='mr-10' style={{ display: 'flex' }}><IconCheck /></div>
                    <div>{row.nombre}</div>
                </div>}
            {row.type === typeCobEnum.COMBO && (row.obligatoria || row.checked) &&
                <div className='ml-30'>
                    <RadioButton
                        field={`sa_${row.idCob}`}
                        catalog={row.catalog}
                        label=''
                        value={row.sa}
                        onChangeStr={onChangeCheck2}
                        isRequired={(row.obligatoria || row.checked)}
                        onChange={() => { }}
                    />
                </div>
            }
            {row.type === typeCobEnum.ESPECIAL_COB && (row.obligatoria || row.checked) && <>
                <div className='lbl-input-auto-cr' style={{ display: 'flex', justifyContent: 'space-around' }}>
                    <label >Descripción</label>
                    <label>Valor del equipo</label>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Input
                        field={`kitSpecialName_${row.idCob}`}
                        id={`kitSpecialName_${row.idCob}`}
                        label='Descripción'
                        value={row.kitSpecialName ?? ''}
                        onChange={onChangeInput}
                        isRequired={(row.obligatoria || row.checked)}
                        onlyInput={true}
                        cssClassStyle='ml-20 w80'
                    />
                    <Input
                        field={`kitSpecialSA_${row.idCob}`}
                        id={`kitSpecialSA_${row.idCob}`}
                        label='Valor del equipo'
                        value={row.kitSpecialSA?.toString() ?? ''}
                        onChange={onChangeInput2}
                        type='CURRENCY_FORMAT'
                        isRequired={(row.obligatoria || row.checked)}
                        onlyInput={true}
                        cssClassStyle='ml-20 w80'
                        prefix={prefix}
                    />
                </div>
            </>}
        </>
    )
}

export { TableRow }
